import { Box, type BoxProps, Img } from '@chakra-ui/react'

import chakraTokenToVar from '@/utils/chakraTokenToVar'

import Avatar from './Avatar'

type AvatarWithIconSize = 'sm' | 'md'

const SIZE_TO_UI_DETAILS: Record<
  AvatarWithIconSize,
  {
    boxSize: BoxProps['width']
    avatarSize: BoxProps['width']
    borderRadius: BoxProps['borderRadius']
  }
> = {
  sm: {
    boxSize: '32px',
    avatarSize: '21px',
    borderRadius: '2px',
  },
  md: {
    boxSize: '48px',
    avatarSize: '32px',
    borderRadius: '4px',
  },
}

export default function AvatarWithIcon({
  user,
  iconEntity,
  size,
  hideOnlineBadge = false,
}: {
  user: React.ComponentProps<typeof Avatar>['user']
  iconEntity: { iconUrl: string; primaryColor?: string }
  size: 'sm' | 'md'
  hideOnlineBadge?: boolean
}): JSX.Element {
  const { primaryColor, iconUrl } = iconEntity
  const { boxSize, avatarSize, borderRadius } = SIZE_TO_UI_DETAILS[size]

  return (
    <Box width={boxSize} height={boxSize} position="relative">
      <Img
        bg={primaryColor}
        src={iconUrl}
        cursor="default"
        width={avatarSize}
        height={avatarSize}
        position="absolute"
        top="0"
        left="0"
        borderRadius={borderRadius}
      />
      <Avatar
        user={user}
        outline={`2px solid ${chakraTokenToVar('fg.contrast')}`}
        position="absolute"
        bottom="0"
        right="0"
        size="sm"
        hideOnlineBadge={hideOnlineBadge}
        width={avatarSize}
        height={avatarSize}
      />
    </Box>
  )
}
